import BaseSystemApi from 'api/BaseSystemApi';

export default class DecisionProcessingApi<Resource = unknown> extends BaseSystemApi<Resource> {
  protected origin = process.env.REACT_APP_DE_API_URL;
}
